<template>
    <div class="fee_indexBox">
	    <div class="feeTitBox">Platform Fees</div>
	    <div class="fee_msgBox">Your monthly Peiso fees will be deducted from the credit card you add here.</div>
	    <div class="fee_cardBox">
		    <span class="fee_cardMsg">Card Number</span>
		    <span class="fee_cardNum" v-if="!load">
				<span v-if="!showAdd">{{showCard?showCard:"**** **** **** ****"}}</span>
				<i v-if="!showAdd" class="el-icon-edit-outline mycard_icon" @click="editCardDio=true"></i>
				<i v-if="showAdd" class="my-add-icon mycard_icon" @click="editCardDio=true"></i>
		    </span>
	    </div>
	    <div>
			<el-table
			:data="tableData"
			border
			class="roster_table fee_table"
			style="width: 100%">
				<el-table-column
				prop="month"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="Month">
					<!-- 25-Sep -->
				</el-table-column>
				<el-table-column
				prop="name"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="Monthly Fee">
					<template slot-scope="scope">
                        ${{scope.row.monthlyFee?scope.row.monthlyFee:'0.00'}}
                    </template>
				</el-table-column>
				<el-table-column
				prop="address"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="Status">
					<template slot-scope="scope">
						<div v-if="scope.row.status==1" style="color:#3BD578">Processed</div>
						<div v-else style="color:#EE9650">Unprocessed</div>
					</template>
				</el-table-column>
				<!-- <el-table-column
				prop="address"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="Tax Invoice">
					<template>
						<i class="el-icon-upload2" style="font-size:26px"></i>
					</template>
				</el-table-column> -->
                <template slot="empty">
                    <i v-if="load" class="el-icon-loading" style="font-size:20px"></i>
                    <div v-else style="font-size:18px">No Data</div>
                </template>
			</el-table>
			<div class="ros_footerPage">
				<el-pagination
					class="my_pageSel"
					layout="prev, pager, next"
					:page-size="10"
                    :current-page.sync='page'
                    @current-change='changePage'
					:total="total">
				</el-pagination>
			</div>
		</div>

		<!-- 修改卡弹框-->
        <el-dialog
        :title="showAdd?'Add Card':'Edit Card'"
        :visible.sync="editCardDio"
        :modal-append-to-body="false"
        :show-close='false'
        class="editCardDio"
        @close="closeDio"
        :close-on-click-modal='false'
        width="840px"
        center>
            <div>
                <div class="tag_tit">Card Number</div>
                <div class="cardNumBox">
                    <input v-model="cardmsg.cardNumWithStars" maxlength="16"
                    @input="detectCard"
                    @blur="validateCardFormat('card')" class="border-input">
                </div>
                <div class="tag_tit">Full Name</div>
                <el-input v-model="cardmsg.cardName" maxlength="30"  class="borderNone"></el-input>
                <div class="cardNumBox">
                    <div class="expireBox">
                        <div class="tag_tit">Expire</div>
                        <div class="expireBox_inside">
                            <input v-model="cardmsg.expMonthWithStars"
                            class="border-input1" ref="expMonth" maxlength="2"
                            @input="detectMonth"
                            @keyup="nextFocus1($event,0,cardmsg.expMonthWithStars)">
                            <span style="line-height:50px;">/</span>
                            <input v-model="cardmsg.expYearWithStars"
                            class="border-input1" ref="expYear" maxlength="2"
                            @input="detectYear"
                            @keyup="nextFocus1($event,1,cardmsg.expYearWithStars)">
                        </div>
                    </div>
                    <div class="expireBox">
                        <div class="tag_tit">CVV</div>
                        <el-input v-model="cardmsg.cardCvvWithStars"
                        @input="detectCvv"
                        @blur="validateCardFormat()"
                        class="borderNone" :maxlength="cvvLength"></el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editCardDio = false" class="cardCanBtn">Cancel</el-button>
                <el-button @click="editcard" class="cardConBtn">Confirm</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="isTrialEnd" class="peiso-modal" width="810px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
			<free-trial-notice :info="venueDiscountDetailsPojo" :isPro="isPro" @close-notice="closeOrLogoutVenue"></free-trial-notice>
		</el-dialog>
  </div>
</template>

<script>
import api from '../../api/api';
import freeTrialNotice from '@/components/modal/freeTrialNotice';
import Utils from '../../utils/utils';
export default {
	data() {
		return {
			tableData:[],
			editCardDio:false,
            noPerfection:false,
            page:1,
            size:10,
            total:0,
            showCard:'',
            showAdd:false,
            load:false,
			cardmsg:{ //卡信息
                cardNum:'',
                cardNumWithStars: '',
                cardNumWithStarsInitial: '',
                cardName:'',
                cardCvv:'',
                cardCvvWithStars: '',
                cardCvvWithStarsInitial: '',
                expMonth:'',
                expMonthWithStars: '',
                expMonthWithStarsInitial: '',
                expYear:'',
                expYearWithStars: '',
                expYearWithStarsInitial: '',
            },
            cvvLength: 4,
            isCardFormRight: true,
            changed: false,
            isPro: false,
			isDoneLoad: false,
			venueDiscountDetailsPojo: null,
      		isTrialEnd: false,
		}
	},
    created() {
        window.sessionStorage.removeItem('cardMsg')
    },
	methods:{
        detectCard() {
            if (((this.cardmsg.cardNumWithStars !== this.cardmsg.cardNumWithStarsInitial) ||
                (this.cardmsg.cardCvvWithStars !== this.cardmsg.cardCvvWithStarsInitial) ||
                (this.cardmsg.expMonthWithStars !== this.cardmsg.expMonthWithStarsInitial) ||
                (this.cardmsg.expYearWithStars !== this.cardmsg.expYearWithStarsInitial)) &&
                !this.changed && !this.showAdd){
                this.cardmsg.cardNumWithStars = ''
                this.cardmsg.cardCvvWithStars = ''
                this.cardmsg.expMonthWithStars = ''
                this.cardmsg.expYearWithStars = ''
                this.changed = true
                return
            }
            this.cardmsg.cardNumWithStars = this.cardmsg.cardNumWithStars.replace(/[^\d]/g,'')
            this.changed = true
        },
        detectCvv() {
            if (((this.cardmsg.cardNumWithStars !== this.cardmsg.cardNumWithStarsInitial) ||
                (this.cardmsg.cardCvvWithStars !== this.cardmsg.cardCvvWithStarsInitial) ||
                (this.cardmsg.expMonthWithStars !== this.cardmsg.expMonthWithStarsInitial) ||
                (this.cardmsg.expYearWithStars !== this.cardmsg.expYearWithStarsInitial)) &&
                !this.changed && !this.showAdd){
                this.cardmsg.cardNumWithStars = ''
                this.cardmsg.cardCvvWithStars = ''
                this.cardmsg.expMonthWithStars = ''
                this.cardmsg.expYearWithStars = ''
                this.changed = true
                return
            }
            this.cardmsg.cardCvvWithStars = this.cardmsg.cardCvvWithStars.replace(/[^\d]/g,'')
            this.changed = true
        },
        detectYear() {
            if (((this.cardmsg.cardNumWithStars !== this.cardmsg.cardNumWithStarsInitial) ||
                (this.cardmsg.cardCvvWithStars !== this.cardmsg.cardCvvWithStarsInitial) ||
                (this.cardmsg.expMonthWithStars !== this.cardmsg.expMonthWithStarsInitial) ||
                (this.cardmsg.expYearWithStars !== this.cardmsg.expYearWithStarsInitial)) &&
                !this.changed && !this.showAdd){
                this.cardmsg.cardNumWithStars = ''
                this.cardmsg.cardCvvWithStars = ''
                this.cardmsg.expMonthWithStars = ''
                this.cardmsg.expYearWithStars = ''
                this.changed = true
                return
            }
            this.cardmsg.expYearWithStars = this.cardmsg.expYearWithStars.replace(/[^\d]/g,'')
            this.changed = true
        },
        detectMonth() {
            if (((this.cardmsg.cardNumWithStars !== this.cardmsg.cardNumWithStarsInitial) ||
                (this.cardmsg.cardCvvWithStars !== this.cardmsg.cardCvvWithStarsInitial) ||
                (this.cardmsg.expMonthWithStars !== this.cardmsg.expMonthWithStarsInitial) ||
                (this.cardmsg.expYearWithStars !== this.cardmsg.expYearWithStarsInitial)) &&
                !this.changed && !this.showAdd){
                this.cardmsg.cardNumWithStars = ''
                this.cardmsg.cardCvvWithStars = ''
                this.cardmsg.expMonthWithStars = ''
                this.cardmsg.expYearWithStars = ''
                this.changed = true
                return
            }
            this.cardmsg.expMonthWithStars = this.cardmsg.expMonthWithStars.replace(/[^\d]/g,'')
            this.changed = true
        },
        validateCardFormat(type) {
            let card = this.cardmsg.cardNum.replace(/[^\d.]/g,'')
            let cvv = this.cardmsg.cardCvv
            if ((card.length === 15 && cvv.length === 4) || (card.length === 16 && cvv.length === 3)){
                this.isCardFormRight = true
            } else if (card.length > 0 && cvv.length > 0){
                this.isCardFormRight = false
                // Utils.alert2('', 'Please enter the correct credit card format', 'error')
            } else if (card.length === 0 && cvv.length === 0) {
                this.isCardFormRight = true
            } else {
                this.isCardFormRight = false
            }
            if (type === 'card' && card.length === 16) {
                this.cvvLength = 3
                // 失焦后给卡号分割分割
                this.cardmsg.cardNum = card.slice(0, 4) + ' ' + card.slice(4, 8) + ' ' + card.slice(8, 12) + ' ' + card.slice(12)
            } else if (type === 'card' && card.length === 15) {
                this.cvvLength = 4
                // 失焦后给卡号分割分割
                this.cardmsg.cardNum = card.slice(0, 4) + ' ' + card.slice(4, 10) + ' ' + card.slice(10)
            } else{
                this.cvvLength = 4
            }
        },
        changePage(page){
			this.page = page
			this.getList()
		},
        getList(){
            let pat={
                pageNum:this.page,
                pageSize:this.size,
            }
            api.getPlatformFeesList(pat,res=>{
                let {code,data,message}=res.data;
                if(code==0){
                    this.tableData=data.list;
                    this.total=data.total;
                    this.tableData.forEach(item=>{
                        item.monthlyFee = Utils.formatSplit(item.monthlyFee)
                    })
                }else{
                    Utils.alert2('',message,'error')
                }
            })
        },
        getcard(){ // 获取卡信息
            this.load = true
            api.getCardInfo({},res=>{
                this.load = false
                let {code,data,message}=res.data;
                if(code==0){
                    if(data==null){
                        this.showAdd = true
                        return
                    }

                    if (Utils.checkValueExists(data.cardNumber)){
                        this.showAdd = false
                        this.showCard = data.cardNumber.length === 16 ? `**** **** **** ${data.cardNumber.slice(12)}` : `xxxx xxxxxx ${data.cardNumber.slice(10)}`
                    }else{
                        this.showAdd = true
                        this.showCard = ''
                    }

                    (data.cardNumber.slice(0, 4) + ' ' + data.cardNumber.slice(4, 10) + ' ' + data.cardNumber.slice(10))
                    this.cardmsg.cardName=data.cardName

                    this.cardmsg.expMonthWithStars = data.expire.split('/')[0]
                    this.cardmsg.expMonthWithStarsInitial = data.expire.split('/')[0]

                    this.cardmsg.expYearWithStars = data.expire.split('/')[1]
                    this.cardmsg.expYearWithStarsInitial = data.expire.split('/')[1]

                    this.cardmsg.cardCvvWithStars = data.cvv
                    this.cardmsg.cardCvvWithStarsInitial = data.cvv
                    this.cardmsg.cardNumWithStars = this.showCard
                    this.cardmsg.cardNumWithStarsInitial = this.showCard
                    window.sessionStorage.setItem('cardMsg',JSON.stringify(this.cardmsg))
                }else{
                    Utils.alert2('',message,'error')
                }
            })
        },
        editcard(){
            if (!this.isCardFormRight) {
                Utils.alert2('', 'Please enter the correct credit card format', 'error')
                return
            }
            if(!this.cardmsg.cardNumWithStars||!this.cardmsg.cardName||!this.cardmsg.expMonthWithStars||!this.cardmsg.expYearWithStars||!this.cardmsg.cardCvvWithStars){
                Utils.alert2('','Imperfect information','error')
                return
            }
            let pat={
                cardNumber: this.changed ? this.cardmsg.cardNumWithStars.replace(/[^\d.]/g,'') : this.cardmsg.cardNumWithStarsInitial.replace(/\s+/g,""),
                cardName:this.cardmsg.cardName,
                expMonth: this.changed ? this.cardmsg.expMonthWithStars : this.cardmsg.expMonthWithStarsInitial,
                expYear: this.changed ? this.cardmsg.expYearWithStars : this.cardmsg.expYearWithStarsInitial,
                cvv: this.changed ? this.cardmsg.cardCvvWithStars : this.cardmsg.cardCvvWithStarsInitial,
            }
            pat.expire = `${pat.expMonth}/${pat.expYear}`
            api.editCardInfo(pat,res=>{
                let {code,data,message}=res.data;
                this.editCardDio=false;
                this.getcard()
                if(code==0){
                    Utils.alert2('','Successfully saved card','success')
                }else{
                    Utils.alert2('',message,'error')
                }
            })
        },
        closeDio(){
            let msg = window.sessionStorage.getItem('cardMsg')
            this.changed = false
            if(msg && !this.showAdd){
                this.cardmsg = JSON.parse(msg)
            } else {
                this. cardmsg ={ //卡信息
                    cardNumWithStars: '',
                    cardNumWithStarsInitial: '',
                    cardCvvWithStars: '',
                    cardCvvWithStarsInitial: '',
                    expYearWithStars: '',
                    expYearWithStarsInitial: '',
                    expMonthWithStars: '',
                    expMonthWithStarsInitial: '',
                    cardName:'',
                }
            }
        },
		nextFocus(el,index,val) {
            var dom = document.getElementsByClassName("border-input"),
            currInput = dom[index],
            nextInput = dom[index + 1],
            lastInput = dom[index - 1];
            if (el.keyCode != 8&&val.split('').length==4) { //8为删除
                if (index < 3) {
                    nextInput.focus();
                } else {
                    currInput.blur();
                }
            }else if(val.split('').length==0){
                if (index !=0) {
                    lastInput.focus();
                }
            }
        },
        nextFocus1(el,index,val) {
            var dom = document.getElementsByClassName("border-input1"),
            currInput = dom[index],
            nextInput = dom[index + 1],
            lastInput = dom[index - 1];
            if (el.keyCode != 8&&val.split('').length==2) { //8为删除
                if (index < 1) {
                    nextInput.focus();
                } else {
                    currInput.blur();
                }
            }else if(val.split('').length==0){
                if (index !=0) {
                    lastInput.focus();
                }
            }
        },
        closeOrLogoutVenue(isSubscribe) {
			if (isSubscribe) {
				this.isTrialEnd = false
				return
			}
			if (this.venueDiscountDetailsPojo.remainingDays <= 0) {
				this.$root.$emit('logout-venue')
			} else {
				const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
				if (isContUsingTrial == '0') {
				sessionStorage.setItem('isContUsingTrial', '1')
				}
				this.isTrialEnd = false
			}
		}
    },
    mounted() {
        this.getcard()
        this.getList()

        this.$root.$on('isPro', (isPro, others) => {
			this.isPro = isPro
			this.isDoneLoad = true

			const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
			if (others.venueDiscountDetailsPojo && others.venueDiscountDetailsPojo.remainingDays <= 3 && isContUsingTrial == '0') {
				this.venueDiscountDetailsPojo = others.venueDiscountDetailsPojo
				this.isTrialEnd =  true
			}
		})
    },
	computed:{
        newcardName(){
            return this.cardmsg.cardName
        },
        newcardCvv(){
            return this.cardmsg.cardCvv
        },
        newexpMonth(){
            return this.cardmsg.expMonth
        },
        newexpYear(){
            return this.cardmsg.expYear
		}
	},
	watch: {
		cardmsg:{
            handler(n,o){
                if(n.cardNum1&&n.cardNum2&&n.cardNum3&&n.cardNum4&&n.expMonth&&n.expYear&&n.cardName&&n.cardCvv){
                    this.noPerfection=false
                }else{
                    this.noPerfection=true
                }
            },
            deep:true
		},
        newcardCvv(n,o){
            if(n){
                let reg = /^\d+(\d)?$/;
                if (new RegExp(reg).test(n) == false && n!='') {
                    setTimeout(() => {
                    this.cardmsg.cardCvv = o;
                    }, 100);
                }
            }
        },
        newexpMonth(n,o){
            if(n){
                let reg = /^\d+(\d)?$/;
                if (new RegExp(reg).test(n) == false && n!='') {
                    setTimeout(() => {
                        this.cardmsg.expMonth = o;
                    }, 100);
                }
                if(n>12){
                    this.cardmsg.expMonth = o;
                }
            }
        },
        newexpYear(n,o){
            if(n){
                let reg = /^\d+(\d)?$/;
                if (new RegExp(reg).test(n) == false && n!='') {
                    setTimeout(() => {
                        this.cardmsg.expYear = o;
                    }, 100);
                }
            }
        },
	},
    components: {
        freeTrialNotice: freeTrialNotice
    }
}
</script>

<style lang="scss">
	.fee_indexBox{
		width: 100%;
		margin-bottom: 30px;
		.feeTitBox{
			width:160px;
			height:33px;
			font-size:24px;
			font-weight:600;
			color:var(--text-color);
			line-height:33px;
			margin-bottom: 40px;
		}
		.fee_msgBox{
			height:28px;
			font-size:20px;
			font-weight:400;
			color:var(--text-color);
			line-height:28px;
			margin-bottom: 30px;
		}
		.fee_cardBox{
			display: flex;
			height: 70px;
			box-sizing: border-box;
			align-items: center;
			padding: 0 30px;
			background-color: var(--background-color-3);
			margin-bottom: 30px;
			.fee_cardMsg{
				height:28px;
				font-size:20px;
				font-weight:600;
				color:var(--text-color);
				line-height:28px;
			}
			.fee_cardNum{
				height:28px;
				font-size:20px;
				font-weight:600;
				color:var(--text-color);
				line-height:28px;
				margin-left: auto;
				.mycard_icon{
					margin-left: 30px;
					font-size: 28px;
					cursor: pointer;
				}
			}
		}
		.ros_footerPage{
			display: flex;
			justify-content: center;
		}

		.tag_tit{
			height:16px;
			font-size:14px;
			font-family:SFProText;
			font-weight:400;
			color:var(--text-color);
			line-height:16px;
			margin: 30px 0 10px 0;
		}
        .my-add-icon{
            display: inline-block;
            width: 24px;
            height: 24px;
            mask-repeat: no-repeat !important;
            mask-position: center center!important;
            mask-size: contain!important;
            background-color: var(--text-color);
            mask: url('../../../static/img/add.png');
            -webkit-mask: url('../../../static/img/add.png');
            background-size: contain;
        }
	}
</style>



// WEBPACK FOOTER //
// src/components/fees/fee.vue